// frontend/src/utils/logger.js

// Simple console logger wrapper for the frontend
// You can expand this later to integrate with a logging service if needed.

const isDevelopment = import.meta.env.DEV; // Vite specific way to check for development mode

const logger = {
  log: (...args) => {
    if (isDevelopment) {
      console.log('[LOG]', ...args);
    }
  },
  info: (...args) => {
    if (isDevelopment) {
      console.info('[INFO]', ...args);
    }
  },
  warn: (...args) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },
  error: (...args) => {
    // Errors should probably always be logged
    console.error('[ERROR]', ...args);
  },
  debug: (...args) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  },
  trace: (message, ...args) => {
    if (isDevelopment) {
      console.groupCollapsed(`[TRACE] ${message}`);
      console.log(...args);
      console.trace('Trace initiated here');
      console.groupEnd();
    }
  }
};

export default logger;